export default "__VITE_ASSET__e2f141ae__"